import { TechnicalIssuesOptionValue } from 'modules/unsubscribe/pages/TechnicalIssues/constants'

export const FEMI_TECHNICAL_ISSUES_VALUES = [
  TechnicalIssuesOptionValue.INCOMPATIBLE_DEVICE,
  TechnicalIssuesOptionValue.SHOP_LINKS_DONT_WORK,
  TechnicalIssuesOptionValue.PROGRESS_NOT_SAVED,
  TechnicalIssuesOptionValue.DONT_UNDERSTAND_LANGUAGE,
  TechnicalIssuesOptionValue.OTHER,
]
